new Promise((res,rej)=>{
    timer = setInterval(()=>{
      let father = document.querySelector('.goog-te-gadget')
      if (father){
        clearInterval(timer)
        res('ok')
      }
    },1000)
  }).then(value=>{
    let father = document.querySelector('.goog-te-gadget')
    if (father){
      let child_list = father.childNodes
      console.log(child_list)
      child_list[1].data = ''
      child_list[2].innerText = ''
      child_list[3].data = ''
    
      let father2 = document.querySelector('.goog-te-combo')
      father2.innerHTML = '<option value="">言語を選ぶ</option><option value="ja" class="japan">日本語</option><option value="en" class = "english">英語</option>'
    
      father2.onclick = function(e){
        console.log('a??????????????')
        e.preventDefault()
        e.stopPropagation
        father2.innerHTML = '<option value="">言語を選ぶ</option><option value="ja" class="japan">日本語</option><option value="en" class = "english">英語</option>'
      }
    }  
  })


